import React from "react";
import { Spinner } from "react-bootstrap";

function CommonButtonSpinner(props) {
  return (
    <>
      <Spinner className="ms-2 d-none" size="sm" animation="border" />
    </>
  );
}

export default CommonButtonSpinner;
